import { CreateDrawerFormProps, FormDrawer } from "@dgs/core";
import { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FilterItem, FilterMode, FilterOptionResource, OnDemandFilterFormValues } from "../filterTypes";
import { emptyQuickFilter, emptyQuickFilterItems } from "../utils";
import { EventFilterFormDrawerContent } from "./EventFilterFormDrawerContent";

interface Props extends CreateDrawerFormProps<OnDemandFilterFormValues> {
	filter: FilterOptionResource | null;
}

export const EventFilterDrawer: FC<Props> = ({ filter, ...drawerProps }) => {
	const { t } = useTranslation();
	const initialValues = useMemo(
		() =>
			filter
				? {
						...filter,
						filterItems:
							filter.mode === FilterMode.QUICK
								? emptyQuickFilterItems.map((item) => filter.filterItems.find((i) => item.field === i.field) ?? item)
								: filter.filterItems,
					}
				: emptyQuickFilter,
		[filter],
	);

	const validate = useCallback(
		(filter: OnDemandFilterFormValues) => {
			const errors: { [K in keyof OnDemandFilterFormValues]?: any } = {};
			filter.filterItems.forEach((item, index) => {
				const error: { [K in keyof FilterItem]?: any } = {};

				if (!item.operator) {
					error.operator = t("Field is required");
				}

				if (filter.mode === FilterMode.ADVANCED && item.value == null) {
					error.value = t("Field is required");
				}

				if (item.operator === "BETWEEN" && item.value && item.value.start > item.value.end) {
					error.value = { start: t("Start must before end"), end: t("Start must before end") };
				}

				if (Object.keys(error).length) {
					errors.filterItems = { ...errors.filterItems, [index]: error };
				}
			});

			return errors;
		},
		[t],
	);

	return (
		<FormDrawer
			{...drawerProps}
			title={t("Filter")}
			validate={validate}
			initialValues={initialValues}
			onClose={() => drawerProps.onClose?.()}
			renderForm={(props) => <EventFilterFormDrawerContent {...props} />}
		/>
	);
};
